import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  OnInit,
  Output,
  Renderer2,
  SimpleChanges,
  ViewChild,
} from '@angular/core'
import { FormGroup } from '@angular/forms'
import { AngularDraggableDirective, AngularResizableDirective, IPosition } from 'angular2-draggable'
import { RoleColor } from '../constants'
import { FieldRenderService } from './field-render.service'
import { Destroyable } from '@tokeet-frontend/tv3-platform'
import { SignFieldRect } from '@tokeet-frontend/signature'

let renderId = 0
@Component({
  selector: 'app-field-renderer',
  templateUrl: './field-renderer.component.html',
  styleUrls: ['./field-renderer.component.scss'],
})
export class FieldRendererComponent extends Destroyable implements OnInit, OnChanges, AfterViewInit {
  @Input() form: FormGroup
  @Input() zoomScale = 1
  @Input() roles: RoleColor[] = []
  @Input() isRoleEditable = true
  @Input() boundsRef: HTMLElement
  @Input() inBounds = true
  @Input() offsetRect: SignFieldRect
  @Input() role2ColorMapping: any = {}
  @Input() resizableEdges = 'se,sw,ne,nw'
  @Input() isCustomField = false
  @Input() isValueCustomizable = false
  @Input() isRequiredEditable = true
  @Input() isEditableGuestDataDictField = false
  @Input() prefillType: string

  @Input() disableCustomFont = false

  @HostBinding('id')
  private renderId = `field-render-${renderId++}`

  @HostBinding('class.active') get isActive() {
    return this.renderId === this.fieldRenderService.activeRenderId
  }

  @ViewChild('draggableElement', {
    read: ElementRef,
    static: true,
  })
  draggableElement: ElementRef
  @ViewChild(AngularDraggableDirective) draggable: AngularDraggableDirective
  @ViewChild('resizableElement', {
    read: ElementRef,
    static: true,
  })
  resizableElement: ElementRef
  @ViewChild(AngularResizableDirective) resizable: AngularResizableDirective
  @ViewChild('fieldConfigPop') fieldConfigPop: ElementRef
  @ViewChild('fieldConfigPopArrow') fieldConfigPopArrow: ElementRef

  @Output() remove: EventEmitter<any> = new EventEmitter<any>()
  @Output() roleChange: EventEmitter<any> = new EventEmitter<any>()
  @Output() afterMove: EventEmitter<any> = new EventEmitter<any>()
  @Output() afterResize: EventEmitter<any> = new EventEmitter<any>()

  get role() {
    return this.form && this.form.get('role').value
  }

  configPopStyle = {
    backgroundColor: 'white',
    border: 'none',
    boxShadow: '0 0 5px rgba(0, 0, 0, 0.5)',
  }

  isSettingShown = false
  settingsPopListeners = []

  private settingsHost: HTMLElement

  constructor(private render: Renderer2, private elRef: ElementRef, public fieldRenderService: FieldRenderService) {
    super()
  }

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.offsetRect) {
      this.setPlaceholderStyle()
    }
  }

  ngAfterViewInit(): void {
    this.settingsHost = document.getElementById('field-setting-host')
  }

  onShowSettings() {
    this.fieldRenderService.setActiveId(this.renderId)
    this.settingsHost.innerHTML = ''
    this.render.appendChild(this.settingsHost, this.fieldConfigPop.nativeElement)
    this.render.addClass(this.settingsHost, 'show')
    this.render.setStyle(this.fieldConfigPop.nativeElement, 'display', `block`)
  }

  onHideSettings() {
    this.fieldRenderService.setActiveId(null)
    this.render.removeChild(this.settingsHost, this.fieldConfigPop.nativeElement)
    this.render.removeClass(this.settingsHost, 'show')
    this.render.setStyle(this.fieldConfigPop.nativeElement, 'display', `none`)
  }

  private setPlaceholderStyle() {
    if (this.resizableElement) {
      this.resizable?.resetSize()
      const resizableElm = this.resizableElement.nativeElement
      this.render.setStyle(resizableElm, 'backgroundColor', this.role2ColorMapping[this.role])
      this.render.setStyle(resizableElm, 'width', `${this.offsetRect.width}px`)
      this.render.setStyle(resizableElm, 'height', `${this.offsetRect.height}px`)
      this.render.setStyle(resizableElm, 'top', `0`)
      this.render.setStyle(resizableElm, 'left', `0`)
    }
    if (this.draggableElement) {
      this.draggable?.resetPosition()
      const draggableElm = this.draggableElement.nativeElement
      this.render.setStyle(draggableElm, 'transform', `translate(${this.offsetRect.x}, ${this.offsetRect.y})`)
    }
  }

  refreshRoleColor() {
    const resizableElm = this.resizableElement?.nativeElement
    if (resizableElm) {
      this.render.setStyle(resizableElm, 'backgroundColor', this.role2ColorMapping[this.role])
    }
  }

  onRemove($event) {
    this.remove.emit()
    if (this.isActive) {
      this.onHideSettings()
    }
  }

  onRoleChange($event) {
    this.refreshRoleColor()
    this.roleChange.emit(this.role)
  }

  onMoveEnd($event: IPosition) {
    this.afterMove.emit()
  }

  onResizeStop() {
    this.afterResize.emit()
  }
}
